import { useState, useEffect } from "react";

export function useSubsidies() {
  const [subsidies, setSubsidies] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);

  useEffect(() => {
    fetch("/data/subsidies.json")
      .then((res) => {
        if (!res.ok) throw new Error("補助金データの読み込みに失敗しました");
        return res.json();
      })
      .then((data) => setSubsidies(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return { subsidies, loading, error };
}
